import { normalizeRewardfulVia } from "@/lib/rewardful";

export const CREATOR_BIO_FLAG = "creator_bio_mobile_v1";
export const TJ_BIO_FLAG = "tj_bio_mobile_v1";
export const ALEX_BIO_FLAG = "alex_bio_mobile_v1";

export function getCreatorBioExperiment(via?: string) {
  if (via === "cine") return { flag: ALEX_BIO_FLAG, exposureEvent: "alex_bio_experiment_entered" };
  return via === "tj"
    ? { flag: TJ_BIO_FLAG, exposureEvent: "tj_bio_experiment_entered" }
    : { flag: CREATOR_BIO_FLAG, exposureEvent: "creator_bio_experiment_entered" };
}

export function getCreatorBioCampaign(search: URLSearchParams) {
  const via = search.get("via");
  if (!via || normalizeRewardfulVia(via) !== via) return null;
  const expected = { utm_source: "twitter", utm_medium: "organic_social", utm_campaign: CREATOR_BIO_FLAG, placement: "bio" };
  if (["via", ...Object.keys(expected), "utm_content"].some((key) => search.getAll(key).length > 1)) return null;
  if (search.has("utm_content") || Object.entries(expected).some(([key, value]) => search.has(key) && search.get(key) !== value)) return null;
  const attribution = new URLSearchParams(search);
  for (const [key, value] of Object.entries(expected)) attribution.set(key, value);
  return { via, attribution };
}

const CREATOR_BIO_PATHS = new Set(["/learning-center/bio", "/learning-center/bio/tj", "/learning-center/bio/alex"]);

export function bioLandingParams(pathname: string, search: URLSearchParams): URLSearchParams {
  if (!CREATOR_BIO_PATHS.has(pathname)) return search;
  return getCreatorBioCampaign(search)?.attribution ?? search;
}

export function isMobileBioVisitor(userAgent: string, width: number) {
  return width > 0 && width <= 767 && /iPhone|iPod|Android.*Mobile/i.test(userAgent);
}
